module.exports = __webpack_public_path__ + "media/22.7214a24b.mp3";